import { Component, ContentChildren, QueryList } from '@angular/core';

import { TableHeaderComponent } from '../table-header/table-header.component';

@Component({
  selector: 'app-table-headers',
  templateUrl: './table-headers.component.html',
  styleUrls: ['./table-headers.component.scss'],
})
export class TableHeadersComponent {
  @ContentChildren(TableHeaderComponent)
  headers: QueryList<TableHeaderComponent>;
}
